import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Modal, Form, InputNumber, Card, message, Row } from 'antd';
import { projectionRequests } from '../../requests';
import { validateCurrency } from '../../utils/validation';
import { getFormattedDouble } from '../../utils/format';
import MyPieChart from '../myPieChart/MyPieChart';


const getPieData = (total, projectionValue) => {
  let achieved = total * 100 / projectionValue;
  achieved = achieved > 100 ? 100 : parseFloat(achieved.toFixed(2));
  const toGoal = parseFloat((100 - achieved).toFixed(2));
  return [
    { name: 'Realizado', value: achieved, color: '#4CAF50' },
    { name: 'Necessário para a projeção', value: toGoal, color: '#F44336' },
  ];
}

const ProjectionDisplay = ({ total, projectionValue, name }) => {
  const [pieData, setPieData] = useState([]);

  useEffect(() => {
    setPieData(getPieData(total, projectionValue));
  }, [total, projectionValue]);


  return (
    <div>
      <Card style={{ width: '100%' }}>
        <Row justify="space-between" align="middle">
          <Col span={12} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              Total: {total ? `R$ ${getFormattedDouble(total)}` : '---'}
            </div>
          </Col>
          <Col span={12} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              Projetado: {projectionValue ? `R$ ${getFormattedDouble(projectionValue)}` : '---'}
            </div>
          </Col>
        </Row>
      </Card>
      <MyPieChart title={name} data={pieData} show={!!projectionValue} />
    </div>
  );
};

export default ProjectionDisplay;
